const seo = {
    title: 'PlayHex',
    description: 'Play the Hex board game with other players or with AI.',
};

export {
    seo,
};
